import { AppstoreAddOutlined } from '@ant-design/icons';
import React, { Fragment, useContext } from 'react';
import { useStore } from 'zustand';

import { EmptyState } from 'app/components/pages/Extranet/commons/EmptyState/EmptyState';
import { SETUP_PACK_TAG_LABEL } from 'app/components/pages/Extranet/commons/SetupPackTag/SetupPackTag';
import { ModernHotelContext } from 'app/context/HotelContext/ModernHotelContext';
import { isPackInSetup } from 'app/utils/extranet';

import {
  InventoryTabItemName,
  inventoryStore,
} from '../../../../../InventoryStore';
import { useRowState } from '../../../../../hooks/useRowState';
import { CollapsibleTableRow } from '../../../../Table/CollapsibleTableRow/CollapsibleTableRow';
import { SectionRow } from '../../../../Table/SectionRow/SectionRow';

import { RoomPriceDiscountRow } from './RoomPriceDiscountRow';

const RoomPackPricesRowComponent: React.FC<{
  roomId: number;
  roomName: string;
}> = ({ roomId, roomName }) => {
  const { getExtranetVisiblePacksContainingRoom } =
    useContext(ModernHotelContext);
  const isEditMode = useStore(inventoryStore, (state) => state.isEditMode);

  const { inventoryPacks } = useRowState(InventoryTabItemName.Packs);

  if (!inventoryPacks) {
    return null;
  }

  const publishedPacks = getExtranetVisiblePacksContainingRoom(roomId).filter(
    (pack) => !pack.isDaytime
  );

  return (
    <CollapsibleTableRow
      panelKey={`pack-prices-${roomId}`}
      label="Total package prices"
      expandWhen={isEditMode}
    >
      {publishedPacks.length === 0 ? (
        <EmptyState
          title="No published packages"
          description="Contact your AM to associate a package to this room."
          icon={<AppstoreAddOutlined />}
        />
      ) : (
        publishedPacks.map((pack) => (
          <Fragment key={`section-${roomId}-${pack.id}`}>
            <SectionRow
              labels={[roomName, pack.nameForHotel]}
              tags={isPackInSetup(pack.status) ? [SETUP_PACK_TAG_LABEL] : []}
            />
            <RoomPriceDiscountRow packId={pack.id} roomId={roomId} />
          </Fragment>
        ))
      )}
    </CollapsibleTableRow>
  );
};

export const RoomPackPricesRow = React.memo(RoomPackPricesRowComponent);
